import React, { useState } from "react"
import { PricingCalculatorComponent } from "../../components/PricingCalculator"
import { US_CONFIG } from "../../utils/PricingUtils"
import { PasswordScreen } from "../../components/PasswordScreen"
import Layout from "../../components/Layout"
import Header from "../../components/Header"

export function Index() {
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  if (!isAuthenticated) {
    return <PasswordScreen onSuccess={() => setIsAuthenticated(true)} />
  }

  return (
    <Layout
      title="Premagic Pricing United States - AI Event Platform Plans"
      description="Affordable AI event platform pricing for the United States. Transparent plans for conferences, corporates & trade shows. Start free trial."
      keywords={[
        "Premagic pricing India, AI event platform cost, event technology pricing India, conference platform pricing, corporate event pricing, Indian event platform rates, photo sharing pricing United States, networking platform cost, enterprise event pricing, MICE platform pricing, event management pricing, conference technology rates, Indian market pricing, affordable event platform, event AI pricing United States",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Pricing", url: "/pricing/us/" },
      ]}
    >
      <Header />
      <PricingCalculatorComponent config={US_CONFIG} />
    </Layout>
  )
}

export default Index
